import { render, staticRenderFns } from "./CoreStrengths.vue?vue&type=template&id=e482dc54&"
import script from "./CoreStrengths.vue?vue&type=script&lang=js&"
export * from "./CoreStrengths.vue?vue&type=script&lang=js&"
import style0 from "./CoreStrengths.vue?vue&type=style&index=0&id=e482dc54&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports